<template>
  <div>
    <review-tags-settings-list
      :tags="review.tags"
      :can-edit="canEdit"
      :disabled="disabled"
      :small="small"
      @createTag="createTag"
      @updateTag="updateTag"
      @deleteTag="deleteTag"
    />
  </div>
</template>

<script>
import { Review } from '@/models';
import ReviewTagsSettingsList from './ReviewTagsSettingsList';

export default {
  name: 'ReviewTagsSettingsPanel',
  components: {
    ReviewTagsSettingsList,
  },
  props: {
    review: {
      type: Review,
      required: true,
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['createTag', 'updateTag', 'deleteTag'],
  methods: {
    createTag(tag) {
      this.$emit('createTag', tag);
    },
    updateTag(tag) {
      this.$emit('updateTag', tag);
    },
    deleteTag(tag) {
      this.$emit('deleteTag', tag);
    },
  },
};
</script>
